module.exports = __webpack_public_path__ + "static/media/cam-placeholder.2b21b8e8.svg";